export default "__VITE_ASSET__VRZWWjWU__"